import React, { useState } from 'react';
import {
  startOfWeek,
  endOfWeek,
  format,
  eachDayOfInterval,
  addWeeks,
  isSameDay,
  isBefore,
  startOfDay,
} from 'date-fns';
import './weeklyCalendar.scss';
import moment from 'moment';  // Make sure this import is at the top of the file

import { LeftArrowIcon, RightArrowIcon } from '../../components/Icons';

const WeeklyCalendar = (props) => {
  // State to keep track of the current displayed week and the selected day
  const [currentWeek, setCurrentWeek] = useState(0);
  const [selectedDay, setSelectedDay] = useState(new Date()); // Set default to today

  // Get the current date
  const currentDate = new Date();

  // Calculate the start date of the current week
  const startOfCurrentWeek = startOfWeek(addWeeks(currentDate, currentWeek), {
    weekStartsOn: 1, // Assuming week starts on Monday (change to 0 for Sunday)
  });

  // Calculate the end date of the current week
  const endOfCurrentWeek = endOfWeek(addWeeks(currentDate, currentWeek), {
    weekStartsOn: 1,
  });

  // Get an array of dates for the current week
  const weekDays = eachDayOfInterval({ start: startOfCurrentWeek, end: endOfCurrentWeek });

  // Function to check if a date is in the past
  const isPastDate = (date) => isBefore(startOfDay(date), startOfDay(currentDate));

  // Event handler for next week button
  const handleNextWeek = () => {
    setCurrentWeek((prevWeek) => prevWeek + 1);
  };

  // Event handler for previous week button
  const handlePrevWeek = () => {
    setCurrentWeek((prevWeek) => prevWeek - 1);
  };

  // Event handler for day click
  const handleDayClick = (day) => {
    if (!isPastDate(day)) {
      setSelectedDay(day);  // This will now set the correct local day
      props.selectTime('');  // Reset the selected time
      props.setSelectedDay(day);  // Send the local day to the parent component
      props.fetchSlots(moment(day).startOf("day").format("YYYY-MM-DDTHH:mm:ss"));
    }
  };

  const handleChooseTime = (time, status) => {
    if(status === 1){
      props.selectTime(time);
    }
  }

  return (
    <div className="weekly-calendar">
      <div className='weekly-calendar-header'>
        <button className='btn btn-light left' onClick={handlePrevWeek}><LeftArrowIcon /></button>
        <div className='month-name-wrap'>{format(startOfCurrentWeek, 'MMMM yyyy')}</div>
        <button className='btn btn-light right' onClick={handleNextWeek}><RightArrowIcon/></button>
      </div>
      <div className='weekly-calendar-days'>
        {weekDays.map((day, index) => (
          <div
            key={index}
            onClick={() => handleDayClick(day)}
            className={isSameDay(day, selectedDay) ? 'active day-wrap' : isPastDate(day) ? 'past day-wrap' : 'day-wrap'}
          >
           <div className='week'>{format(day, 'EEE')}</div>
           <div className='day'>{format(day, 'd')}</div>
          </div>
        ))}
      </div>
      <div className="slots box-wrapper">
        {props.slots && props.slots.data ? (
          Object.entries(props.slots.data).map(([hour, value]) => (
            <button
              onClick={()=>{handleChooseTime(hour, value)}}
              key={hour}
              disabled={value === 0 || value === 2 || value === 3}
              className={`btn ${props.selectedTime === hour ? 'active' : ''} ${value === 1 ? 'green' : 'red'}`}

            >
              <div className='dot-wrap'><span></span></div>
              <div className='hour'>{hour}</div>
            </button>
          ))
        ) : (
          <p>No slots available</p>
        )}
      </div>
    </div>
  );
};

export default WeeklyCalendar;
